import React from 'react';
import TextHelper from '@/core/helpers/TextHelper';
import {
  Card,
  CardBody,
  CardBodyList,
  CardHeader,
  ColumnCard,
  ColumnCard2
} from '../styled';

interface Props {
  mySummaryCourse: any;
}

const CourseResume: React.FC<Props> = (props) => {
  const { mySummaryCourse } = props;

  return (
    <Card>
      <CardHeader>
        <span>Resumen general</span>
      </CardHeader>
      <CardBody>
        <CardBodyList>
          <ColumnCard>
            <div>
              Campus:{' '}
              {mySummaryCourse.campus ? (
                <span>
                  {mySummaryCourse.campus === 'CAMPUS VIRTUAL'
                    ? 'UTP'
                    : mySummaryCourse.campus}
                </span>
              ) : (
                <span>-</span>
              )}
            </div>
            <div>
              Cursos matriculados:{' '}
              {mySummaryCourse.enrolledCourses ? (
                <span>{mySummaryCourse.enrolledCourses.padStart(2, '0')}</span>
              ) : (
                <span>-</span>
              )}
            </div>
            <div>
              Promedio:{' '}
              {mySummaryCourse.average ? (
                <span>{Number(mySummaryCourse.average).toFixed(2)}</span>
              ) : (
                <span>-</span>
              )}
            </div>
            <div>
              Ciclo relativo:{' '}
              {mySummaryCourse.relativeCycle ? (
                <span>
                  {TextHelper.capitalize(
                    mySummaryCourse.relativeCycle,
                    false,
                    true
                  )}
                </span>
              ) : (
                <span>-</span>
              )}
            </div>
          </ColumnCard>
          <ColumnCard2>
            <div>
              Cantidad de créditos:{' '}
              {mySummaryCourse.creditCount ? (
                <span>{Number(mySummaryCourse.creditCount).toFixed(0)}</span>
              ) : (
                <span>-</span>
              )}
            </div>
            <div>
              Mérito - Orden:{' '}
              {mySummaryCourse.meritOrder ? (
                <span>
                  {TextHelper.capitalize(
                    mySummaryCourse.meritOrder,
                    false,
                    true
                  )}
                </span>
              ) : (
                <span>-</span>
              )}
            </div>
            <div>
              Horas semanales:{' '}
              {mySummaryCourse.weeklyHours ? (
                <span>{Number(mySummaryCourse.weeklyHours).toFixed(0)}</span>
              ) : (
                <span>-</span>
              )}
            </div>
            <div>
              Mérito - Pertenece:{' '}
              {mySummaryCourse.meritBelong &&
              mySummaryCourse.meritBelong.toUpperCase() !== 'NINGUNO' ? (
                <span>
                  {TextHelper.capitalize(
                    mySummaryCourse.meritBelong,
                    false,
                    true
                  )}
                </span>
              ) : (
                <span>-</span>
              )}
            </div>
          </ColumnCard2>
        </CardBodyList>
      </CardBody>
    </Card>
  );
};

export default CourseResume;
